<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <br />
        <div *ngIf="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="mt-2">Cargando información del profesional...</p>
        </div>
        
        <div *ngIf="hasError" class="alert alert-danger" role="alert">
            <h4 class="alert-heading">Error al cargar los datos</h4>
            <p>{{ errorMessage }}</p>
            <hr>
            <p class="mb-0">Por favor, intente nuevamente más tarde o contacte al administrador.</p>
        </div>
        
        <div *ngIf="!isLoading && !hasError">
            <div class="text-start">
                <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item"><a [routerLink]="['/home/freelancer']">Profesionales</a></li>
                        <li class="breadcrumb-item"><a [routerLink]="['/home/freelancer']">{{ professionalData()?.professionalProfileName || 'Profesional' }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{{ professionalData()?.firstName }} {{ professionalData()?.lastName }}</li>
                    </ol>
                </nav>
            </div>
            <!-- Main container with profile view tracking -->
            <!-- Uses candidate's publicResumeId for unified tracking -->
            <div class="container" 
     appViewTracker 
     [viewType]="ViewType.IndependentProfile" 
     [entityId]="trackingResumeId">
  <!-- ...existing content... -->
</div>
            
            <div class="row mt-2 mb-2">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <img [src]="getPhotoUrl()" class="img-fluid rounded" alt="Foto del profesional" style="height: 400px; width: 100%; object-fit: contain;" />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <p class="mt-0 mb-0 text-left text-small">
                        <i class="fa-regular fa-clock"></i>
                        Experiencia: {{ calculateTotalExperience() }} | <i class="fa-solid fa-tag"></i> {{ formatChargeInfo() }}
                    </p>
                    <h5 class="mt-2 mb-1 text-primary">
                        {{ professionalData()?.professionalProfileName || 'Profesional Independiente' }}
                    </h5>
                    <h2 class="mt-0 mb-2">
                        {{ professionalData()?.firstName }} {{ professionalData()?.lastName }}
                    </h2>
                    <h5 class="text-secondary mt-1 mb-1" *ngIf="professionalData()?.email">
                        <i class="fa-regular fa-envelope"></i>
                        {{ professionalData()?.email }}
                    </h5>
                    <h5 class="text-secondary mt-1 mb-1" *ngIf="professionalData()?.cellPhone">
                        <i class="fa-solid fa-mobile-screen"></i>
                        {{ professionalData()?.cellPhone }}
                    </h5>
                    <h5 class="text-secondary mt-1 mb-1" *ngIf="professionalData()?.nationality">
                        <i class="fa-solid fa-location-dot"></i>
                        {{ professionalData()?.nationality }}
                    </h5>
                    <p class="text-justify" *ngIf="resumeData()?.description">
                        {{ resumeData()?.description }}
                    </p>
                </div>
            </div>
        <hr class="mt-2 mb-2" />
        <div class="row" *ngIf="!isLoading && !hasError">
            <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="text-primary mt-1 mb-1">
                            Acerca de
                        </h5>
                        <hr class="mt-3 mb-3" />
                        <div class="row">
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="professionalData()?.birthDate">
                                <label class="text-secondary">Edad</label>
                                <div class="mb-2">
                                    {{ professionalData()?.birthDate ? calculateAge(professionalData()?.birthDate) : 0 }} años
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="professionalData()?.cellPhone || professionalData()?.primaryPhone">
                                <label class="text-secondary">Teléfono</label>
                                <div class="mb-2">
                                    {{ professionalData()?.cellPhone || professionalData()?.primaryPhone }}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="professionalData()?.nationality">
                                <label class="text-secondary">Nacionalidad</label>
                                <div class="mb-2">
                                    {{ professionalData()?.nationality }}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="resumeData()?.personalInfo">
                                <label class="text-secondary">Vehículo</label>
                                <div class="mb-2">
                                    {{ resumeData()?.personalInfo?.hasVehicle ? 'Sí' : 'No' }}
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12" *ngIf="resumeData()?.personalInfo">
                                <label class="text-secondary">Licencia</label>
                                <div class="mb-2">
                                    {{ resumeData()?.personalInfo?.hasDriverLicense ? 'Sí' : 'No' }}
                                </div>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" *ngIf="resumeData()?.personalInfo?.address">
                                <label class="text-secondary">Dirección</label>
                                <div class="mb-2">
                                    {{ resumeData()?.personalInfo?.address }}
                                </div>
                            </div>
                        </div>
                        
                        <h5 class="text-primary mt-1 mb-1" *ngIf="resumeData()?.employments && resumeData()?.employments!.length > 0">
                            Experiencia Laboral
                        </h5>
                        <hr class="mt-3 mb-3" *ngIf="resumeData()?.employments && resumeData()?.employments!.length > 0" />
                        <div class="card mb-3" *ngFor="let employment of resumeData()?.employments">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <label class="text-secondary">Cargo desempeñado</label>
                                        <div class="mb-2">
                                            {{ employment?.position || 'No especificado' }}
                                        </div>
                                        <label class="text-secondary">Compañía</label>
                                        <div class="mb-2">
                                            {{ employment?.company || 'No especificada' }}
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <label class="text-secondary">Periodo</label>
                                        <div class="mb-2">
                                            {{ employment?.startDate ? (employment?.startDate | date: 'dd/MM/yyyy') : 'No especificado' }} - 
                                            <span *ngIf="employment?.currentJob; else showEndDate">Actual</span>
                                            <ng-template #showEndDate>
                                                {{ employment?.endDate ? (employment?.endDate | date: 'dd/MM/yyyy') : 'No especificado' }}
                                            </ng-template>
                                        </div>
                                        <label class="text-secondary" *ngIf="employment?.salaryExpectation">
                                            Expectativa salarial
                                        </label>
                                        <div class="mb-2" *ngIf="employment?.salaryExpectation">
                                            {{ employment?.salaryExpectation }}
                                        </div>
                                    </div>
                                </div>
                                <p class="text-justify" *ngIf="employment?.responsibility">
                                    {{ employment?.responsibility }}
                                </p>
                                <div *ngIf="employment?.achievement">
                                    <label class="text-secondary">Logros:</label>
                                    <p class="text-justify">
                                        {{ employment?.achievement }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div class="alert alert-info" *ngIf="!resumeData()?.employments || resumeData()?.employments!.length === 0">
                            No hay información de experiencia laboral disponible.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="text-primary mt-1 mb-1">
                            Educación
                        </h5>
                        <hr class="mt-2 mb-2" />
                        <div *ngIf="resumeData()?.educations && resumeData()?.educations!.length > 0">
                            <div class="mb-3" *ngFor="let education of resumeData()?.educations">
                                <h5 class="mt-0 mb-1">
                                    <span class="badge rounded-pill text-bg-primary">{{ education.startDate | date: 'yyyy' }}</span>
                                    {{ education?.educationLevel || 'No especificado' }}
                                </h5>
                                <strong>Estado:</strong> {{ education?.resumeEducationStatus || 'En curso' }}<br />
                                <strong>Institución:</strong> {{ education?.institution || 'No especificada' }} 
                                <p *ngIf="education?.description" class="mt-1 mb-0 small text-muted">{{ education?.description }}</p>
                            </div>
                        </div>
                        <div class="alert alert-info" *ngIf="!resumeData()?.educations || resumeData()?.educations!.length === 0">
                            No hay información de educación disponible.
                        </div>

                        <h5 class="text-primary mt-3 mb-1">
                            Certificaciones
                        </h5>
                        <hr class="mt-2 mb-2" />
                        <div *ngIf="resumeData()?.certifications && resumeData()?.certifications!.length > 0">
                            <div class="mb-3" *ngFor="let certification of resumeData()?.certifications">
                                <h5 class="mt-0 mb-1">
                                    {{ certification?.name || 'No especificado' }}
                                </h5>
                                <strong>Vigencia:</strong> {{ certification?.completionDate | date: 'dd/MM/yyyy' }} 
                                <span *ngIf="certification?.expirationDate">al {{ certification?.expirationDate | date: 'dd/MM/yyyy' }}</span>
                                <span *ngIf="!certification?.expirationDate"> - Sin vencimiento</span><br />
                                <strong>Institución:</strong> {{ certification?.institution || 'No especificada' }}
                                <p *ngIf="certification?.description" class="mt-1 mb-0 small text-muted">{{ certification?.description }}</p>
                            </div>
                        </div>
                        <div class="alert alert-info" *ngIf="!resumeData()?.certifications || resumeData()?.certifications!.length === 0">
                            No hay información de certificaciones disponible.
                        </div>

                        <h5 class="text-primary mt-4 mb-1">
                            Habilidades
                        </h5>
                        <hr class="mt-2 mb-2" />
                        <div *ngIf="resumeData()?.skills && resumeData()?.skills!.length > 0">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-start" *ngFor="let skill of resumeData()?.skills">
                                    <div class="ms-0 me-auto">
                                        {{ skill?.skillName || 'No especificado' }}
                                    </div>
                                    <span class="badge text-bg-primary rounded-pill">{{ skill?.skillLevel || 'Básico' }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="alert alert-info" *ngIf="!resumeData()?.skills || resumeData()?.skills!.length === 0">
                            No hay información de habilidades disponible.
                        </div>

                        <h5 class="text-primary mt-4 mb-1">
                            Idiomas
                        </h5>
                        <hr class="mt-3 mb-3" />
                        <div *ngIf="resumeData()?.languages && resumeData()?.languages!.length > 0">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-start" *ngFor="let language of resumeData()?.languages">
                                    <div class="ms-0 me-auto">
                                        {{ language?.languageName || 'No especificado' }}
                                    </div>
                                    <span class="badge text-bg-primary rounded-pill">{{ language?.languageLevel || 'Básico' }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="alert alert-info" *ngIf="!resumeData()?.languages || resumeData()?.languages!.length === 0">
                            No hay información de idiomas disponible.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div *ngIf="!isLoading && !hasError">
            <h5 class="mt-2 mb-2">
                <i class="fa-solid fa-user-tie"></i>
                Otros Profesionales
            </h5>
            
            <div *ngIf="otherProfessionalsLoading" class="text-center py-3">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-2">Cargando otros profesionales...</p>
            </div>
            
            <div *ngIf="!otherProfessionalsLoading && profesionals.length === 0" class="alert alert-info">
                No hay otros profesionales disponibles en este momento.
            </div>
            
            <div class="row" *ngIf="!otherProfessionalsLoading && profesionals.length > 0">
                <ng-container *ngFor="let item of profesionals">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
                        <a [routerLink]="['/home/freelancer-detail', item.id, item.resumeId]" class="text-decoration-none">
                            <div class="card card-shop mb-3">
                                <div class="card-img-top">
                                    <img [src]="item.foto" class="img-fluid" alt="foto" />
                                </div>
                                <div class="card-body position-relative">
                                    <p class="mt-0 mb-0 text-left text-small">
                                        <i class="fa-regular fa-clock"></i>
                                        {{ item.experiencia }} | <i class="fa-solid fa-tag"></i> {{ item.price }}
                                    </p>
                                    <h5 class="mt-0 mb-0 text-primary">
                                        {{ item.profesional }}
                                    </h5>
                                    <p class="mt-0 mb-0 text-left">
                                        {{ item.nombreCompleto }}
                                    </p>
                                </div>
                            </div>    
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>